var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "w-full flex pt-2 flex-col" }, [
    _c(
      "div",
      { staticClass: "w-full" },
      [
        _c(
          "field",
          { staticClass: "mb-3", attrs: { label: "Contract Type" } },
          [
            _c("dropdown-field", {
              attrs: {
                source: _vm.contractSource,
                "text-field": "contractField",
                placeholder: "Select Contract",
              },
              model: {
                value: _vm.selectedContract,
                callback: function ($$v) {
                  _vm.selectedContract = $$v
                },
                expression: "selectedContract",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "field",
          { staticClass: "mb-2", attrs: { label: "Contract Name" } },
          [
            _c("dropdown-field", {
              attrs: {
                source: _vm.nameSource,
                "text-field": "fValue",
                "value-field": "fValue",
                "taggable-add-item-text": "Add name",
                "taggable-no-items-found-text": "Add New Name with ENTER or",
                placeholder: "-- Select name or type new name --",
                taggable: "",
                searchable: "",
              },
              on: {
                "add-tag": function ($event) {
                  return _vm.addNewValue($event)
                },
              },
              model: {
                value: _vm.fValue,
                callback: function ($$v) {
                  _vm.fValue = $$v
                },
                expression: "fValue",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex flex-row-reverse pt-4" },
      [
        _c(
          "btn",
          {
            on: {
              click: function ($event) {
                return _vm.closeProp()
              },
            },
          },
          [_vm._v("Update Name")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }